export const states = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

const getAccountPerson = (account = {}, useContextHubDataSource = false) => {
  if (useContextHubDataSource) {
    return {
      firstName: account.firstName || '',
      lastName: account.lastName || '',
    };
  }

  const { person } = account;

  return {
    firstName: (person && person.firstName) || '',
    lastName: (person && person.lastName) || '',
  };
};

const getAccountAddress = (account = {}, useContextHubDataSource = false) => {
  if (useContextHubDataSource) {
    const { address } = account;

    if (!address) {
      return undefined;
    }

    return {
      addressLine1: address.line1,
      addressLine2: address.line2,
      city: address.city,
      state: address.state,
      zip: address.zip,
    };
  }

  return account.serviceAddress;
};

export const formatBillingAddress = (account = {}, form = {}, useContextHubDataSource = false) => {
  const billingAddress = {};
  const accountPerson = getAccountPerson(account, useContextHubDataSource);

  billingAddress.person = {
    firstName: form.firstName || accountPerson.firstName,
    lastName: form.lastName || accountPerson.lastName,
  };

  billingAddress.address = (
    form.billingAddressCheckbox
      ? {
        addressLine1: form.line1,
        addressLine2: form.line2,
        city: form.city,
        state: form.state,
        zip: form.zip,
      }
      : getAccountAddress(account, useContextHubDataSource)
  );
  return billingAddress;
};
